module.exports = __webpack_public_path__ + "static/media/Odin.5a285377.jpg";